import { CLIENT_FLOWS } from '@global/constants/general';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: { [key: string]: any } = {
  showInitScreen: import.meta.env.VITE_CLIENT_FLOW === CLIENT_FLOWS.CM ? false : true
};

const formData = createSlice({
  name: 'form-data',
  initialState,
  reducers: {
    updateFormData(state, action: PayloadAction<object>) {
      return { ...state, ...action.payload };
    },
    clearFormData(_state, action: PayloadAction<object>) {
      return { ...initialState, ...action.payload };
    }
  }
});

const { actions, reducer } = formData;
export const { updateFormData, clearFormData } = actions;
export default reducer;
